export const enum PrivateRoutesEnum {
  DASHBOARD = '/dashboard',
  CREATE_TEST = '/createTest/:id',
  PUBLISH_TEST = '/publishTest',
  ANALYTICS = '/analytics/:id',
  MU_SURVEY = '/mySurvey',
}

export const enum PublicRoutesEnum {
  AUTH = '/authorization',
  TAKING_SURVEY = '/walkthrough/:hash/:preview?',
}
